import {Component, Emitter} from '@wonderlandengine/api';

/**
 * Keeps track of which hand is last used and emits an event when it changes.
 */
export class ActiveHand extends Component {
    static TypeName = 'active-hand';

    private _activeHand: 'left' | 'right' = 'right';

    public get activeHand(): 'left' | 'right' {
        return this._activeHand;
    }
    private set activeHand(value: 'left' | 'right') {
        if (value === this._activeHand) {
            return;
        }
        this._activeHand = value;
        this.onActiveHandChanged.notify(value);
    }

    onActiveHandChanged: Emitter<['left' | 'right']> = new Emitter();

    onActivate(): void {
        this.engine.onXRSessionStart.add(this.onSessionStart);
    }

    onDeactivate(): void {
        this.engine.onXRSessionStart.remove(this.onSessionStart);

        if(this.engine.xr) {
            this.engine.xr.session.removeEventListener(
                'squeezestart',
                this.torchHandSelect
            );
            this.engine.xr.session.removeEventListener(
                'selectstart',
                this.torchHandSelect
            );
        }
    }

    onSessionStart = () => {
        this.engine.xr!.session.addEventListener(
            'squeezestart',
            this.torchHandSelect
        );
        this.engine.xr!.session.addEventListener(
            'selectstart',
            this.torchHandSelect
        );
    }

    torchHandSelect = (event: {inputSource: XRInputSource}) => {
        switch (event.inputSource.handedness) {
            case 'left':
                this.activeHand = 'left';
                break;
            case 'right':
                this.activeHand = 'right';
                break;
        }
    }
}
